import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-text-left" }
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2 tw-py-6"
}
const _hoisted_3 = {
  key: 1,
  class: "tw-space-y-4"
}
const _hoisted_4 = { class: "tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-4 tw-items-stretch" }
const _hoisted_5 = { class: "tw-h-full tw-flex tw-flex-col dispatch-order-card__address" }
const _hoisted_6 = { class: "tw-h-full tw-flex tw-flex-col dispatch-order-card__address" }
const _hoisted_7 = { class: "tw-h-full tw-flex tw-flex-col dispatch-order-card__address" }
const _hoisted_8 = { class: "tw-overflow-x-auto" }
const _hoisted_9 = { class: "tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700" }
const _hoisted_10 = { class: "tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600" }
const _hoisted_11 = {
  key: 0,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_12 = {
  key: 1,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_13 = { class: "tw-px-4 tw-py-3" }
const _hoisted_14 = { class: "tw-divide-y tw-divide-slate-200/70" }
const _hoisted_15 = { class: "odd:tw-bg-white/30" }
const _hoisted_16 = { class: "tw-px-4 tw-py-3" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = {
  key: 0,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_19 = {
  key: 1,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_20 = {
  key: 2,
  class: "tw-px-4 tw-py-3"
}
const _hoisted_21 = { class: "tw-px-4 tw-py-3" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "tw-px-4 tw-py-3" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "tw-px-4 tw-py-3" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "tw-flex tw-items-center tw-gap-2"
}
const _hoisted_28 = ["disabled"]
const _hoisted_29 = {
  key: 1,
  class: "tw-text-sm tw-text-slate-700"
}
const _hoisted_30 = { class: "tw-px-4 tw-py-3" }
const _hoisted_31 = {
  key: 0,
  class: "tw-text-sm tw-text-slate-700"
}
const _hoisted_32 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_TerminalAddressCard = _resolveComponent("TerminalAddressCard")!
  const _component_ReceiverAddressCard = _resolveComponent("ReceiverAddressCard")!
  const _component_BillToAddressCard = _resolveComponent("BillToAddressCard")!
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_DatePicker = _resolveComponent("DatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.$apollo.queries.order.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_font_awesome_icon, {
            icon: "circle-notch",
            spin: "",
            class: "tw-h-4 tw-w-4 tw-text-slate-500"
          }),
          _cache[10] || (_cache[10] = _createElementVNode("span", { class: "tw-text-sm tw-text-slate-600" }, "Loading order…", -1))
        ]))
      : _createCommentVNode("", true),
    (_ctx.order)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_TerminalAddressCard, {
                order: _ctx.order,
                isExportOrder: _ctx.isExportOrder
              }, null, 8, ["order", "isExportOrder"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_ReceiverAddressCard, {
                onRefreshOrder: _ctx.refreshOrder,
                order: _ctx.order
              }, null, 8, ["onRefreshOrder", "order"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_BillToAddressCard, {
                billingContact: _ctx.order.billingContact,
                orderId: _ctx.order.id,
                billTo: _ctx.order.billTo
              }, null, 8, ["billingContact", "orderId", "billTo"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", _hoisted_10, [
                _createElementVNode("tr", null, [
                  _cache[11] || (_cache[11] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Ship Line", -1)),
                  (_ctx.isExportOrder)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_11, "Booking number"))
                    : (_ctx.order.billOfLading)
                      ? (_openBlock(), _createElementBlock("th", _hoisted_12, "Bill Of Lading"))
                      : _createCommentVNode("", true),
                  _cache[12] || (_cache[12] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Vessel Name", -1)),
                  _createElementVNode("th", _hoisted_13, _toDisplayString(!_ctx.isExportOrder ? 'Vessel ETA' : 'Vessel Cutoff'), 1),
                  _cache[13] || (_cache[13] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Reference #", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, "Billing Customer Ref #", -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("th", { class: "tw-px-4 tw-py-3" }, null, -1))
                ])
              ]),
              _createElementVNode("tbody", _hoisted_14, [
                _createElementVNode("tr", _hoisted_15, [
                  _createElementVNode("td", _hoisted_16, [
                    (!_ctx.isEditingVesselInformation)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.order.shipLine), 1))
                      : (_openBlock(), _createBlock(_component_FilterableDropdown, {
                          key: 1,
                          taggable: "",
                          "push-tag": "",
                          modelValue: _ctx.shipLine,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.shipLine) = $event)),
                          options: _ctx.steamshipLines,
                          components: { OpenIndicator: null, Deselect: null }
                        }, null, 8, ["modelValue", "options"]))
                  ]),
                  (_ctx.order.billOfLading)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.order.billOfLading.billOfLadingId), 1))
                    : (_ctx.isExportOrder && !_ctx.isEditingVesselInformation)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(_ctx.order.bookingNumber), 1))
                      : (_ctx.isExportOrder && _ctx.isEditingVesselInformation)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_20, [
                            _createVNode(_component_InputField, {
                              id: "editBookingNumber",
                              modelValue: _ctx.newBookingNumber,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newBookingNumber) = $event))
                            }, null, 8, ["modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                  _createElementVNode("td", _hoisted_21, [
                    (!_ctx.isEditingVesselInformation)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.order.vesselName), 1))
                      : (_openBlock(), _createBlock(_component_FilterableDropdown, {
                          key: 1,
                          taggable: "",
                          "push-tag": "",
                          modelValue: _ctx.vesselName,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vesselName) = $event)),
                          options: _ctx.filteredVessels,
                          components: { OpenIndicator: null, Deselect: null }
                        }, null, 8, ["modelValue", "options"]))
                  ]),
                  _createElementVNode("td", _hoisted_23, [
                    (!_ctx.isEditingVesselInformation)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.order.vesselEtaString), 1))
                      : (_openBlock(), _createBlock(_component_DatePicker, {
                          key: 1,
                          class: "tw-block",
                          "input-class": 'tw-rounded-md tw-border tw-border-slate-200 tw-bg-white/70 tw-px-2 tw-py-1 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-900/10',
                          format: "MM/DD/YYYY",
                          onInput: _ctx.changedETA,
                          modelValue: _ctx.vesselEta,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.vesselEta) = $event))
                        }, null, 8, ["onInput", "modelValue"]))
                  ]),
                  _createElementVNode("td", _hoisted_25, [
                    (!_ctx.order.referenceNumber)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          (_ctx.isEditingReferenceNumber)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingReferenceNumber) = $event)),
                                  placeholder: "Enter reference #",
                                  class: "tw-w-56 tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/80 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-900/10"
                                }, null, 512), [
                                  [_vModelText, _ctx.editingReferenceNumber]
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white",
                                  title: "Cancel",
                                  "aria-label": "Cancel",
                                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.cancelReferenceNumberEdit && _ctx.cancelReferenceNumberEdit(...args)))
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "xmark",
                                    class: "tw-h-4 tw-w-4"
                                  })
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-text-white hover:tw-bg-slate-800 disabled:tw-opacity-60",
                                  title: "Save",
                                  "aria-label": "Save",
                                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.saveReferenceNumber && _ctx.saveReferenceNumber(...args))),
                                  disabled: !_ctx.editingReferenceNumber
                                }, [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: "check",
                                    class: "tw-h-4 tw-w-4"
                                  })
                                ], 8, _hoisted_28)
                              ]))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white",
                                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.startReferenceNumberEdit && _ctx.startReferenceNumberEdit(...args))),
                                title: "Add",
                                "aria-label": "Add"
                              }, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "plus",
                                  class: "tw-h-4 tw-w-4"
                                })
                              ]))
                        ]))
                      : (!_ctx.isEditingVesselInformation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.order.referenceNumber), 1))
                        : (_openBlock(), _createBlock(_component_InputField, {
                            key: 2,
                            id: "editReferenceNumber",
                            modelValue: _ctx.newReferenceNumber,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newReferenceNumber) = $event))
                          }, null, 8, ["modelValue"]))
                  ]),
                  _createElementVNode("td", _hoisted_30, [
                    (!_ctx.isEditingVesselInformation)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          (_ctx.order.billingReferenceNumber)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.order.billingReferenceNumber), 1))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock(_component_InputField, {
                          key: 1,
                          id: "editReferenceNumber",
                          modelValue: _ctx.newBillingReferenceNumber,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newBillingReferenceNumber) = $event))
                        }, null, 8, ["modelValue"]))
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("td", { class: "tw-px-4 tw-py-3" }, null, -1))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}